import moment from 'moment'

class DossierHelper {
    hourDivider:number;
    totalHoursDay: number;
    totalRealWorkHours: number;
constructor() {
    this.hourDivider = 4;
    this.totalRealWorkHours = 8;
    this.totalHoursDay = 24/8;
  }    

    getDurationStr(duration, withTxt = false) {
        let day = 0;
        let hours = 0;
        let minutes = duration;
        let workhourStr = "";
        let hoursInMinutes = 0;
        
        if(duration > 60) {
            hours = Math.floor(duration / 60);
            if(withTxt) {
                workhourStr += hours+((hours == 1) ? " uur" : " uur");
            } else {
                workhourStr += hours+":";
            }
            hoursInMinutes = hours * 60;
            minutes = duration - hoursInMinutes;
        }
        
            if(minutes > 0) {
                if(withTxt) {
                workhourStr += " "+minutes+((minutes == 1) ? " minuut" : " minuten");
                } 
            } 
            if(!withTxt) {
                    let minStr = ("00"+minutes);
                    workhourStr += minStr.slice(-2);
                
                }
        return workhourStr;
        
    }

    
    getWorkHoursString(workHours) {
        
        let workhourStr = "";
        let dagen = 0;
        if(workHours > this.totalRealWorkHours) {
            dagen = Math.floor(workHours / this.totalRealWorkHours);
            workHours = workHours - (dagen * this.totalRealWorkHours);
            
            workhourStr += dagen+((dagen == 1) ? " dag" : " dagen"); 
        }
            
        
        if(workHours > 0) {
            let workHoursMilliseconds = workHours*60*60*1000;
            let duration = moment.duration((workHoursMilliseconds), 'ms');
            let hours = Math.floor(duration?.asHours());
            if(hours > 0) {
            workhourStr += " "+hours+((hours == 1) ? " uur" : " uur");
            } 
            let minutes = duration?.minutes();
            if(minutes > 0) {
            workhourStr += " "+minutes+((minutes == 1) ? " minuut" : " minuten");
            } 
        }
        return workhourStr;
  
    }
    
    setChildrenLayout(items: Array<any>, optionType: number): Array<any> {
        let returnItems = [...items];
        let parentItem = (returnItems.shift());
        
        let startDate = parentItem.start_timeline;
        let diffInMilliSeconds = parentItem.end_timeline - parentItem.start_timeline;
        let workHoursChildren = Math.floor(diffInMilliSeconds / returnItems.length);
        let newStartDate = null;
        for(let i in returnItems) {
            
            returnItems[i].start_timeline = startDate;
            newStartDate = this.calculateEndTime(startDate, workHoursChildren);
            returnItems[i].workHours = this.calculateWorkHours(startDate, newStartDate);
            returnItems[i].end_timeline = moment(startDate).clone().add(((returnItems[i].workHours * this.totalHoursDay) * 60 * 60 * 1000), 'ms').valueOf();
            
            startDate = newStartDate; 
        }
        
        
        
        
        return items;
    }
    
    calculateEndTime(startTime, millseconds) {
        let newEndDate = moment(startTime).clone().add(millseconds, 'ms').valueOf();
        return newEndDate;
    }
    
    calculateWorkHours(startTime, endTime) {
        let workHours = moment(endTime).diff(startTime, 'hour');
        let workHoursTotal = this.roundByNum(workHours / this.totalHoursDay);
        
        
        return workHoursTotal;
    }

    roundByNum(num, rounder = null) {
        var multiplier = 1/(rounder||0.25);
        return Math.round(num*multiplier)/multiplier;
    }    
}
export default new DossierHelper();